export enum StatsElementMapChartsBlock {
  Root = 'StatsElementMapCharts',
}
